(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apollo-experience"]) return;
  try {
    
  (() => {
    const start = () => {
      const setCatalogMode = (mode, persist) => {
        const selected = mode === 'model' ? 'model' : 'product';
        document.documentElement.dataset.apolloViewMode = selected;
        document.querySelectorAll('button[data-apollo-view]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.apolloView === selected));
        });
        if (persist) {
          try { sessionStorage.setItem('apollo-catalog-view', selected); } catch (_) {}
        }
      };

      let savedCatalogMode = 'product';
      try { savedCatalogMode = sessionStorage.getItem('apollo-catalog-view') || 'product'; } catch (_) {}
      const hasSwitch = !!document.querySelector('button[data-apollo-view]');
      // A collection with no On Model imagery renders no switch. Fall back to
      // Product view for this page without overwriting the saved preference.
      setCatalogMode(hasSwitch ? savedCatalogMode : 'product', false);

      // Put the product information beside the purchase controls rather than in
      // a band under the whole page. It is authored as its own section, so the
      // move happens here and repeats when the theme editor reloads a section.
      let productInfoHome = document.querySelector('.template-product .apollo-product-information')?.parentElement;
      const relocateProductInfo = () => {
        const column = document.querySelector('.template-product .product-content-box');
        const info = productInfoHome?.querySelector('.apollo-product-information') || document.querySelector('.template-product .apollo-product-information');
        if (!column || !info) return;
        if (column.contains(info)) return;
        info.dataset.apolloPlaced = 'true';
        column.appendChild(info);
      };
      if (document.body.dataset.apolloInfoColumn === 'true') {
        relocateProductInfo();
        document.addEventListener('shopify:section:unload', event => {
          const oldColumn = event.target.querySelector('.product-content-box');
          const info = oldColumn?.querySelector('.apollo-product-information');
          if (info && productInfoHome?.isConnected) {
            productInfoHome.appendChild(info);
            delete info.dataset.apolloPlaced;
          }
        });
      }

      const updateHeader = () => {
        const header = document.querySelector('[data-apollo-experience-header]');
        if (!header) return;
        const persistentHeader = document.body.classList.contains('template-collection') || document.body.classList.contains('template-product');
        header.classList.toggle('is-visible', persistentHeader || window.scrollY > 115);
      };
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });

      const updateMenu = () => {
        const menu = document.querySelector('.menu-btn.global-menu');
        if (menu) menu.setAttribute('aria-expanded', document.body.classList.contains('pushy-open-left') || document.body.classList.contains('pushy-open-right') ? 'true' : 'false');
      };
      updateMenu();
      new MutationObserver(updateMenu).observe(document.body, { attributes: true, attributeFilter: ['class'] });

      document.addEventListener('shopify:section:load', event => {
        const freshInfo = event.target.querySelector('.apollo-product-information');
        if (freshInfo && document.body.dataset.apolloInfoColumn === 'true') {
          const oldInfo = document.querySelector('.template-product .product-content-box .apollo-product-information');
          if (oldInfo && oldInfo !== freshInfo) oldInfo.remove();
          productInfoHome = freshInfo.parentElement;
        }
        updateHeader();
        updateMenu();
        const hasSwitchNow = !!document.querySelector('button[data-apollo-view]');
        let savedMode = 'product';
        try { savedMode = sessionStorage.getItem('apollo-catalog-view') || 'product'; } catch (_) {}
        setCatalogMode(hasSwitchNow ? savedMode : 'product', false);
        if (document.body.dataset.apolloInfoColumn === 'true') relocateProductInfo();
      });

      document.addEventListener('click', event => {
        const viewButton = event.target.closest('button[data-apollo-view]');
        if (viewButton) {
          setCatalogMode(viewButton.dataset.apolloView, true);
        }

        const jumpButton = event.target.closest('[data-apollo-buy-jump]');
        if (jumpButton) {
          const purchase = document.querySelector('.template-product #add-to-cart-section');
          if (purchase) {
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            purchase.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'center' });
            const control = purchase.querySelector('select, input[type="submit"]');
            if (control) control.focus({ preventScroll: true });
          }
        }
      });

      const stickyBuy = document.querySelector('[data-apollo-experience-buy]');
      const nativeBuy = document.querySelector('.template-product #add-to-cart-section');
      if (stickyBuy && nativeBuy) {
        const updateBuy = () => {
          const rect = nativeBuy.getBoundingClientRect();
          stickyBuy.classList.toggle('is-visible', rect.bottom < 0);
        };
        updateBuy();
        window.addEventListener('scroll', updateBuy, { passive: true });
        window.addEventListener('resize', updateBuy);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apollo-product-information"] && !Shopify.designMode) return;
  try {
    
  (() => {
      function moveDescriptionSizeCharts() {
        var destination = document.querySelector('[data-description-size-chart]');
        var description = document.querySelector('.product-grid-page__description');
        if (!destination || !description || destination.dataset.sizeChartReady === 'true') return;

        var tables = Array.prototype.slice.call(description.querySelectorAll('table'));
        if (!tables.length) return;

        destination.dataset.sizeChartReady = 'true';
        destination.classList.add('mvr-size-guide', 'mvr-size-guide--description');

        tables.forEach(function (table) {
          var heading = table.previousElementSibling;
          var headingText = heading ? String(heading.textContent || '').trim() : '';
          var moveHeading = heading && /^(H[1-6]|P)$/i.test(heading.tagName) && /(size\s*(chart|guide)|garment\s*measurements?)/i.test(headingText);
          var wrapper = document.createElement('div');
          wrapper.className = 'mvr-size-guide__table-wrap';
          table.classList.add('mvr-size-guide__table');
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
          if (moveHeading) destination.appendChild(heading);
          destination.appendChild(wrapper);
          transformDescriptionSizeTable(table, wrapper);
        });

        var detailsItem = description.closest('[data-product-details-item]');
        var detailsBody = detailsItem ? detailsItem.querySelector('.product-accordion__body') : null;
        var remainingText = String(description.textContent || '').trim();
        var remainingMedia = description.querySelector('img, video, iframe, ul, ol');
        var customDetails = detailsBody ? detailsBody.querySelector('.mvr-product-details-clean') : null;
        var customText = customDetails ? String(customDetails.textContent || '').trim() : '';
        if (detailsItem && !remainingText && !remainingMedia && !customText) detailsItem.hidden = true;
      }

      function transformDescriptionSizeTable(sourceTable, wrapper) {
        var rows = Array.prototype.slice.call(sourceTable.rows || []);
        if (rows.length < 4) return;

        var sizeCells = Array.prototype.slice.call(rows[0].cells || []).slice(1);
        var unitCells = Array.prototype.slice.call(rows[1].cells || []).slice(1);
        var measurementRows = rows.slice(2);
        if (!sizeCells.length || !unitCells.length || !measurementRows.length) return;

        var sizes = sizeCells.map(function (cell) { return String(cell.textContent || '').trim(); }).filter(Boolean);
        var units = [];
        unitCells.forEach(function (cell) {
          var unit = String(cell.textContent || '').trim().toLowerCase();
          if (unit && units.indexOf(unit) === -1) units.push(unit);
        });
        if (!sizes.length || units.length < 2) return;

        var measurements = measurementRows.map(function (row) {
          var cells = Array.prototype.slice.call(row.cells || []);
          return {
            label: cells[0] ? String(cells[0].textContent || '').trim() : '',
            values: cells.slice(1).map(function (cell) { return String(cell.textContent || '').trim(); })
          };
        }).filter(function (measurement) { return measurement.label; });
        if (!measurements.length) return;

        // High Horse's charts span each size across its unit columns with
        // colspan, so the size row lists each size once. A chart that repeats
        // the size instead (S, S, M, M) would index past the end of every row
        // and fill the table with dashes, so those runs are collapsed here. If
        // the shape still does not add up, the styled table is left alone
        // rather than rendering a chart that is quietly wrong.
        var valuesPerRow = measurements[0].values.length;
        var collapsed = sizes.filter(function (size, i) { return i === 0 || size !== sizes[i - 1]; });
        if (collapsed.length * units.length === valuesPerRow) sizes = collapsed;
        if (sizes.length * units.length !== valuesPerRow) return;

        var guide = document.createElement('div');
        guide.className = 'mvr-ald-size-guide';
        var controls = document.createElement('div');
        controls.className = 'mvr-ald-size-guide__units';
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', 'Measurement unit');
        guide.appendChild(controls);

        var table = document.createElement('table');
        table.className = 'mvr-ald-size-guide__table';
        var thead = document.createElement('thead');
        var headRow = document.createElement('tr');
        ['Size'].concat(measurements.map(function (measurement) { return measurement.label; })).forEach(function (label) {
          var th = document.createElement('th');
          th.scope = 'col';
          th.textContent = label;
          headRow.appendChild(th);
        });
        thead.appendChild(headRow);
        table.appendChild(thead);
        var tbody = document.createElement('tbody');
        table.appendChild(tbody);
        var tableRegion = document.createElement('div');
        tableRegion.className = 'mvr-size-guide__table-wrap';
        tableRegion.tabIndex = 0;
        tableRegion.setAttribute('role', 'region');
        tableRegion.setAttribute('aria-label', 'Measurements');
        tableRegion.appendChild(table);
        guide.appendChild(tableRegion);

        function render(unitIndex) {
          tbody.innerHTML = '';
          sizes.forEach(function (size, sizeIndex) {
            var row = document.createElement('tr');
            var sizeHead = document.createElement('th');
            sizeHead.scope = 'row';
            sizeHead.textContent = size;
            row.appendChild(sizeHead);
            measurements.forEach(function (measurement) {
              var cell = document.createElement('td');
              var valueIndex = sizeIndex * units.length + unitIndex;
              cell.textContent = measurement.values[valueIndex] || '—';
              row.appendChild(cell);
            });
            tbody.appendChild(row);
          });
        }

        units.forEach(function (unit, unitIndex) {
          var button = document.createElement('button');
          button.type = 'button';
          button.textContent = unit === 'cm' ? 'CM' : unit === 'inch' || unit === 'in' ? 'IN' : unit.toUpperCase();
          button.className = unitIndex === 0 ? 'is-active' : '';
          button.setAttribute('aria-pressed', unitIndex === 0 ? 'true' : 'false');
          button.addEventListener('click', function () {
            controls.querySelectorAll('button').forEach(function (item) {
              var active = item === button;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            render(unitIndex);
          });
          controls.appendChild(button);
        });

        render(0);
        wrapper.replaceWith(guide);
      }

      function splitMeasurement(value, unit) {
        var parts = String(value || '').split('/');
        var inches = parts[0] ? parts[0].trim() : value;
        var cm = parts[1] ? parts[1].trim() : value;
        if (unit === 'in') return inches;
        if (unit === 'cm') return cm;
        return inches || value;
      }

      function initSizeGuide(guide) {
        if (!guide || guide.dataset.mvrSizeReady === 'true') return;
        guide.dataset.mvrSizeReady = 'true';

        var sizeButtons = guide.querySelectorAll('[data-mvr-size]');
        var unitButtons = guide.querySelectorAll('[data-mvr-unit]');
        var cols = guide.querySelectorAll('[data-mvr-col]');
        var valueCells = guide.querySelectorAll('td[data-mvr-value]');
        var productForm = document.querySelector('[data-product-form-wrap] form');
        var selectedSize = sizeButtons[0] ? sizeButtons[0].dataset.mvrSize : '';
        var selectedUnit = 'in';

        function normaliseSize(value) {
          return String(value || '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '')
            .replace('xxl', '2xl');
        }

        function findProductSizeInput(size) {
          if (!productForm) return null;
          var wanted = normaliseSize(size);
          var sizeSelect = productForm.querySelector('[data-size-select]');
          if (sizeSelect) {
            for (var optionIndex = 0; optionIndex < sizeSelect.options.length; optionIndex++) {
              if (normaliseSize(sizeSelect.options[optionIndex].value) === wanted) {
                sizeSelect.value = sizeSelect.options[optionIndex].value;
                return sizeSelect;
              }
            }
          }
          var inputs = productForm.querySelectorAll('.product-grid-page__field--pills input[type="radio"]');
          for (var i = 0; i < inputs.length; i++) {
            if (normaliseSize(inputs[i].value) === wanted) return inputs[i];
          }
          return null;
        }

        function getSelectedProductSize() {
          if (!productForm) return '';
          var sizeSelect = productForm.querySelector('[data-size-select]');
          if (sizeSelect) return sizeSelect.value;
          var checked = productForm.querySelector('.product-grid-page__field--pills input[type="radio"]:checked');
          return checked ? checked.value : '';
        }

        function render() {
          cols.forEach(function (el) {
            el.classList.toggle('is-active', normaliseSize(el.dataset.mvrCol) === normaliseSize(selectedSize));
          });
          valueCells.forEach(function (cell) {
            cell.textContent = splitMeasurement(cell.dataset.mvrValue, selectedUnit);
          });
        }

        function setChartSize(size) {
          if (!size) return;
          selectedSize = size;
          sizeButtons.forEach(function (btn) {
            btn.classList.toggle('is-active', normaliseSize(btn.dataset.mvrSize) === normaliseSize(selectedSize));
          });
          render();
        }

        sizeButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            setChartSize(button.dataset.mvrSize);

            var productSizeInput = findProductSizeInput(button.dataset.mvrSize);
            if (productSizeInput && (productSizeInput.tagName === 'SELECT' || !productSizeInput.checked)) {
              if (productSizeInput.type === 'radio') productSizeInput.checked = true;
              productSizeInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        if (productForm) {
          productForm.addEventListener('change', function (event) {
            if (!event.target.matches('[data-size-select], .product-grid-page__field--pills input[type="radio"]')) return;
            setChartSize(event.target.value);
          });
        }

        unitButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            selectedUnit = button.dataset.mvrUnit;
            unitButtons.forEach(function (btn) { btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); });
            button.classList.add('is-active');
            button.setAttribute('aria-pressed', 'true');
            render();
          });
        });

        setChartSize(getSelectedProductSize() || selectedSize);
      }

      function initAllSizeGuides() {
        moveDescriptionSizeCharts();
        document.querySelectorAll('[data-mvr-size-guide]').forEach(initSizeGuide);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          initAllSizeGuides();
        });
      } else {
        initAllSizeGuides();
      }
    // High Horse marks its own size select with data-size-select and wraps the
    // purchase form in data-product-form-wrap. Apollo names neither, so the
    // same hooks are applied here and the script above is left untouched.
    function adaptApolloForm() {
      var section = document.querySelector('.apollo-product-information');
      if (!section) return;
      var form = document.querySelector('.template-product .add-to-cart-section form');
      if (form && !document.querySelector('[data-product-form-wrap]')) {
        (form.parentElement || form).setAttribute('data-product-form-wrap', '');
      }
      var name = section.getAttribute('data-apollo-size-select');
      if (!name) return;
      var select = document.querySelector('select.select-field[name="' + name + '"]');
      if (select && !select.hasAttribute('data-size-select')) {
        select.setAttribute('data-size-select', '');
      }
    }

    const boot = () => { adaptApolloForm(); initAllSizeGuides(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
